import {useId, useRef, useState, type ReactNode} from 'react';

/** Keep every panel mounted so changing presentation never discards a field draft. */
export function SourcePanelTabs({label, tabs}: {label: string; tabs: readonly {id: string; label: string; content: ReactNode}[]}) {
  const id = useId();
  const [active, setActive] = useState(tabs[0]!.id);
  const buttons = useRef<(HTMLButtonElement | null)[]>([]);
  return <div className="source-tabs">
    <div role="tablist" aria-label={label} className="source-tab-list">
      {tabs.map((tab, index) => <button key={tab.id} ref={node => {buttons.current[index] = node;}}
        type="button" role="tab" id={`${id}-${tab.id}-tab`} aria-controls={`${id}-${tab.id}-panel`}
        aria-selected={active === tab.id} tabIndex={active === tab.id ? 0 : -1}
        onClick={() => setActive(tab.id)} onKeyDown={event => {
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length : null;
          if (next === null) return;
          event.preventDefault(); setActive(tabs[next]!.id); buttons.current[next]?.focus();
        }}>{tab.label}</button>)}
    </div>
    {tabs.map(tab => <div key={tab.id} role="tabpanel" id={`${id}-${tab.id}-panel`} aria-labelledby={`${id}-${tab.id}-tab`}
      hidden={active !== tab.id} className="source-tab-panel">{tab.content}</div>)}
  </div>;
}

export function SourcePanelHeading({title, context, kind}: {title: string; context?: string; kind?: string}) {
  return <header className="source-panel-heading"><div><h3>{title}</h3>{context && <p>{context}</p>}</div>{kind && <span className="source-panel-kind">{kind}</span>}</header>;
}
